import styled from 'styled-components'
import { theme, Box as BoxComp } from '@/client/components'
const { borders, color, font, space, breakpoint } = theme

export const Box = styled(BoxComp)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${space.xl};
  gap: ${space.lg};

  @media (min-width: ${breakpoint.md}) {
    flex-direction: row;
    padding: ${space.xl3} ${space.xl};
  }

  @media (min-width: ${breakpoint.md}) {
    flex-direction: row;
    padding: ${space.xl3};
  }
`

export const BoxInfos = styled.div`
  width: 100%;
  max-width: 26rem;
  text-align: center;

  @media (min-width: ${breakpoint.md}) {
    text-align: left;
  }
`

export const Positions = styled.div`
  width: 100%;
  margin: ${space.xl4} 0;
  padding: ${space.xl4} 0;
  background-color: ${color.grayscale.lighter};
`

export const Table = styled.div`
  width: 100%;

  @media (min-width: ${breakpoint.lg}) {
    border-radius: ${borders.radius.lg};
    background-color: ${color.grayscale.white};
    box-shadow: 0px 0px 30px #1021331a;
    overflow: hidden;
  }
`

export const TableHeader = styled.div`
  display: none;
  width: 100%;
  padding: 0 ${space.xl2};
  background-color: ${color.primary.darker};
  color: ${color.grayscale.white};
  font-family: ${font.family.heading};
  font-size: ${font.size.h6};
  font-weight: ${font.weight.bold};

  & > div:nth-child(1) {
    width: 50%;
    min-width: 50%;
    padding-left: ${space.xs};
  }

  & > div:nth-child(2),
  & > div:nth-child(3) {
    width: 30%;
  }

  & > div:nth-child(4) {
    width: 16%;
    padding-right: ${space.xs};
  }

  @media (min-width: ${breakpoint.lg}) {
    display: flex;
  }
`

export const TableBody = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space.lg};

  @media (min-width: ${breakpoint.md}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${breakpoint.lg}) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`

export const TableRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space.md};
  padding: ${space.xl};
  border-radius: ${borders.radius.lg};
  background-color: ${color.grayscale.white};
  box-shadow: 0px 0px 30px #596c811a;

  & > div:nth-child(3) {
    order: -1;
  }

  @media (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    width: 100%;
    padding: 0 ${space.xl2};
    border-radius: 0;
    background-color: transparent;
    box-shadow: none;

    &:not(:last-of-type) > div {
      border-bottom: ${borders.sizes.md} dashed ${color.grayscale.lighter};
    }

    & > div:nth-child(1) {
      width: 50%;
      min-width: 50%;
      padding-left: ${space.xs};
    }

    & > div:nth-child(2),
    & > div:nth-child(3) {
      width: 30%;
      order: 0;
    }

    & > div:nth-child(4) {
      width: 16%;
      padding-right: ${space.xs};
    }
  }
`

export const TableCell = styled.div`
  display: flex;
  align-items: center;
  gap: ${space.xs};

  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.xl} 0;
  }
`
